import React from "react";
import { publishGlobalMessage } from "./../global.messages/GlobalMessages";
import { messageVariants } from "./../../constants";

const WithGlobalMessagesHOC = (Component) => {
  const WrappedComponent = (props) => (
    <Component {...props} publishGlobalMessage={publishGlobalMessage} variants={messageVariants} />
  );

  WrappedComponent.displayName = `WithGlobalMessages(${Component.displayName || Component.name || "Component"})`;

  return WrappedComponent;
};

export default WithGlobalMessagesHOC;
